/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';

/**
 * Internal dependencies
 */

export const CircularOptionPickerContext = createContext({});
CircularOptionPickerContext.displayName = 'CircularOptionPickerContext';